// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CloudSyncOutlinedSvg from "@ant-design/icons-svg/es/asn/CloudSyncOutlined";
import AntdIcon from '../components/AntdIcon';

var CloudSyncOutlined = function CloudSyncOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CloudSyncOutlinedSvg
  }));
};

CloudSyncOutlined.displayName = 'CloudSyncOutlined';
export default React.forwardRef(CloudSyncOutlined);